import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.stopreasoncodegroups.components';

export default defineMessages({
  idColumnLabel: {
    id: `${scope}.stopreasoncodegroupsgrid.label.idcolumn`,
    defaultMessage: 'Id',
  },
  nameColumnLabel: {
    id: `${scope}.stopreasoncodegroupsgrid.label.namecolumn`,
    defaultMessage: 'Name',
  },
  descriptionColumnLabel: {
    id: `${scope}.stopreasoncodegroupsgrid.label.descriptioncolumn`,
    defaultMessage: 'Description',
  },
  addStopReasonCodeGroupLabel: {
    id: `${scope}.label.addstopreasoncodegroup`,
    defaultMessage: 'Add stop reason code group',
  },
  editStopReasonCodeGroupLabel: {
    id: `${scope}.label.editstopreasoncodegroup`,
    defaultMessage: 'Edit stop reason code group',
  },
  sortOrderColumnLabel: {
    id: `${scope}.stopreasoncodegroupsgrid.label.sortordercolumn`,
    defaultMessage: 'Sort order',
  },
});